import React from "react";
import HeroBanner from "../../assets/vision_images/HeroBanner.jpg"; 

function Vision() {
  return (
    <div className="min-h-screen">
      
      {/* Vision Hero */}
      <section className="relative h-[70vh] sm:h-[80vh] flex items-center justify-center">
        {/* Background image */}
        <img
          src={HeroBanner}
          alt="Our Vision"
          className="absolute inset-0 w-full h-full object-cover"
        />

        {/* Overlay */}
        <div className="absolute inset-0 bg-black/50"></div>

        {/* Content */}
        <div className="relative z-10 max-w-4xl mx-auto text-center px-6">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white leading-tight mb-6">
            We are committed to improving quality of life for all people
          </h1>

          <p className="text-lg sm:text-xl text-gray-100 leading-relaxed">
            Regardless of race, profession, gender, age, or background
            through our holistic life management curriculums.
          </p>
        </div>
      </section>

            {/* Pillars */}
      <section className="py-20 bg-gradient-to-br from-yellow-50 via-white to-orange-50">
        
        <div className="container-custom max-w-4xl">

          {/* Section Header */}
          <div className="text-center mb-16">
            <p className="text-lg sm:text-xl text-gray-700 leading-relaxed">
            These curriculums integrate <span className="font-semibold text-[#F4900C]">financial literacy</span> and
            <span className="font-semibold text-[#F4900C]"> systemized money management</span> with three core pillars.
          </p>
          </div>

          {/* Pillars List */}
          <div className="space-y-10">
            
            {/* HEAD */}
            <div className="flex items-start gap-6">
              <div className="text-[#F4900C] font-bold text-2xl sm:text-3xl min-w-[90px]">
                HEAD
              </div>

              <div className="flex-1 border-l-4 border-[#FED700] pl-6">
                <p className="text-lg sm:text-xl text-gray-700">
                  Right theory-based learning
                </p>
              </div>
            </div>

            {/* HAND */}
            <div className="flex items-start gap-6">
              <div className="text-[#F4900C] font-bold text-2xl sm:text-3xl min-w-[90px]">
                HAND
              </div>

              <div className="flex-1 border-l-4 border-[#F4900C] pl-6">
                <p className="text-lg sm:text-xl text-gray-700">
                  Skill mastery through practical training
                </p>
              </div>
            </div>

            {/* HEART */}
            <div className="flex items-start gap-6">
              <div className="text-[#F4900C] font-bold text-2xl sm:text-3xl min-w-[90px] ">
                HEART
              </div>

              <div className="flex-1 border-l-4 border-[#FED700] pl-6">
                <p className="text-lg sm:text-xl text-gray-700">
                  Positive attitude cultivation
                </p>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Closing */}
      <section className="py-16 bg-white">
        <div className="container-custom max-w-3xl text-center">
          <p className="text-xl text-gray-700 leading-relaxed">
            Our goal is to make this knowledge
            <span className="font-semibold text-[#F4900C]"> accessible to everyone</span>,
            anytime and anywhere.
          </p>
        </div>
      </section>

    </div>
  );
}

export default Vision;
